import React from "react";

import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes all
import {  authRoutes } from "./routes/allRoutes";


import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";


import * as Env from "./environments";
import Parse from "parse";


Parse.initialize(Env.APPLICATION_ID, Env.JAVASCRIPT_KEY);
Parse.serverURL = Env.SERVER_URL;
Parse.enableLocalDatastore();



const App = (props) => {
  


  return (
    <Routes>
      {authRoutes.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          element={
            route.element ?? (
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            )
          }
        />
      ))}
    </Routes>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
